import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Paper,
} from '@mui/material';
import {
  Tv as TvIcon,
  Image as MediaIcon,
  Restaurant as MenuIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import { fetchTVs } from '../redux/slices/tvSlice';
import { fetchMedia } from '../redux/slices/mediaSlice';
import { fetchMenus } from '../redux/slices/menuSlice';
import TV from '../assets/images/tv.svg';
import QuickAction1 from '../assets/images/quickaction1.svg';
import QuickAction2 from '../assets/images/quickaction2.svg';
import { borderRadius, colors, lineHeights, naturalScale, typography } from '../theme/tokens';
import { RiAddLine } from '@remixicon/react';
import axios from 'axios';

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tvs } = useSelector((state) => state.tv);
  const { allMedia } = useSelector((state) => state.media);
  const { menus } = useSelector((state) => state.menu);
  const userId = 'demo-user'; // Replace with actual user ID from auth

  useEffect(() => {
    dispatch(fetchTVs(userId));
    dispatch(fetchMedia(userId));
    dispatch(fetchMenus(userId));
  }, [dispatch, userId]);

  // const getsearch = async () => {
  //   const response = await axios.get('https://ms.foodhub.com/api/fl/bob-crm/search-takeaway', {
  //     params: {
  //       term: 969,
  //       graveyard: 0
  //     },
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NTgxMiwic3ViIjoieW9zc2VmLnNoYWJhbkBmb29kaHViLmNvbSIsInVzZXJOYW1lIjoiRkgteW9zc2VmLnNoYWJhbiIsImxldmVsIjoiMSIsInR5cGUiOiJJTlRFUk5BTCIsImlzcyI6IkJPQkNSTSIsImlhdCI6MTc2NDUyNDYyMywiZXhwIjoxNzY5NzA4NjIzfQ.3RRXdaBMeLyHnNUbb4SuWNGKRV5OcsqDSZQd8oPkuKY',
  //       'cookie': '__stripe_mid=5449a6de-eaf6-4a83-a99b-9a2a46dfa1f5f3c5ff; PHPSESSID=na4agkua5uv568kduov7kkj5fq; __stripe_sid=308371b5-09dc-46ea-aaaa-579a053bc739ab14f1; bctkn=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NTgxMiwic3ViIjoieW9zc2VmLnNoYWJhbkBmb29kaHViLmNvbSIsInVzZXJOYW1lIjoiRkgteW9zc2VmLnNoYWJhbiIsImxldmVsIjoiMSIsInR5cGUiOiJJTlRFUk5BTCIsImlzcyI6IkJPQkNSTSIsImlhdCI6MTc2NDUyNDYyMywiZXhwIjoxNzY5NzA4NjIzfQ.3RRXdaBMeLyHnNUbb4SuWNGKRV5OcsqDSZQd8oPkuKY; _udept=44; _uid=FH-yossef.shaban',
  //       'language': 'en-gb',
  //     }
  //   });
  //   console.log(response.data);
  // }
  // const getsearchstore = async () => {
  //   const response = await axios.get('https://ms.foodhub.com/api/fl/bob-crm/search-takeaway', {
  //     params: {
  //       storeId: 459
  //     },
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NTgxMiwic3ViIjoieW9zc2VmLnNoYWJhbkBmb29kaHViLmNvbSIsInVzZXJOYW1lIjoiRkgteW9zc2VmLnNoYWJhbiIsImxldmVsIjoiMSIsInR5cGUiOiJJTlRFUk5BTCIsImlzcyI6IkJPQkNSTSIsImlhdCI6MTc2NDUyNDYyMywiZXhwIjoxNzY5NzA4NjIzfQ.3RRXdaBMeLyHnNUbb4SuWNGKRV5OcsqDSZQd8oPkuKY',
  //       'cookie': '__stripe_mid=5449a6de-eaf6-4a83-a99b-9a2a46dfa1f5f3c5ff; PHPSESSID=na4agkua5uv568kduov7kkj5fq; __stripe_sid=308371b5-09dc-46ea-aaaa-579a053bc739ab14f1; bctkn=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NTgxMiwic3ViIjoieW9zc2VmLnNoYWJhbkBmb29kaHViLmNvbSIsInVzZXJOYW1lIjoiRkgteW9zc2VmLnNoYWJhbiIsImxldmVsIjoiMSIsInR5cGUiOiJJTlRFUk5BTCIsImlzcyI6IkJPQkNSTSIsImlhdCI6MTc2NDUyNDYyMywiZXhwIjoxNzY5NzA4NjIzfQ.3RRXdaBMeLyHnNUbb4SuWNGKRV5OcsqDSZQd8oPkuKY; _udept=44; _uid=FH-yossef.shaban',
  //       'language': 'en-gb',
  //     }
  //   });
  //   console.log(response.data);
  // }

  // useEffect(() => {
  //   getsearch();
  //   getsearchstore();
  // }, []);

  const stats = [
    {
      title: 'TVs Paired',
      value: tvs.length,
      icon: <TvIcon sx={{ fontSize: 40 }} />,
      color: 'primary.main',
      action: () => navigate('/tvs'),
    },
    {
      title: 'Media Files',
      value: allMedia.length,
      icon: <MediaIcon sx={{ fontSize: 40 }} />,
      color: 'secondary.main',
      action: () => navigate('/media'),
    },
    {
      title: 'Menus Created',
      value: menus.length,
      icon: <MenuIcon sx={{ fontSize: 40 }} />,
      color: 'success.main',
      action: () => navigate('/menus'),
    },
  ];

  const onlineTVs = tvs.filter((tv) => tv.status === 'online').length;

  return (
    <Box>
      <Paper
        sx={{
          p: 4,
          mb: 4,
          background: 'linear-gradient(86deg, rgba(251, 224, 227, 0.50) -0.01%, rgba(226, 209, 249, 0.50) 100%)',
          color: 'white',
          borderRadius: 2,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Box>
          <Typography variant="h2" fontWeight={600} lineHeight={1.1} sx={{ fontFamily: typography.fontFamily, fontSize: '2.25rem', color: colors.neutral.black }} gutterBottom>
            Hi, Ready to get started?
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: '#353543' }} lineHeight={1.5} fontWeight={400} fontSize={'1rem'}>
            You're one step away! Add your screen and go live with your first menu.
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<RiAddLine />}
            onClick={() => navigate('/tvs')}
            sx={{
              backgroundColor: colors.primary.main,
              color: colors.neutral.white,
              boxShadow: '0 0 0 3px rgba(198, 31, 47, 0.20), 0 0 0 6px rgba(213, 34, 50, 0.10)',
              '&:hover': {
                backgroundColor: colors.primary.main,
                boxShadow: '0 0 0 3px rgba(198, 31, 47, 0.20), 0 0 0 6px rgba(213, 34, 50, 0.10)',
              },
            }}
          >
            Let's Pair Your Screen!
          </Button>
        </Box>
        <img src={TV} alt="TV" />
      </Paper>

      {/* Stats Grid */}
      {/* <Grid container spacing={3} sx={{ mb: 4 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 3,
                },
              }}
              onClick={stat.action}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography variant="h3" fontWeight={700}>
                      {stat.value}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {stat.title}
                    </Typography>
                  </Box>
                  <Box sx={{ color: stat.color }}>{stat.icon}</Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid> */}

      {/* Quick Actions */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: '100%',
              borderRadius: borderRadius.xxs,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              transition: 'all 0.3s ease',
              '&:hover': {
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                transform: 'translateY(-4px)',
              },
            }}
          >
            <CardContent
              sx={{
                p: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                flexGrow: 1,
              }}>
                <Box>
                  <Typography
                    variant="subtitle1"
                    fontWeight={700}
                    fontFamily={typography.fontFamilyHeading}
                    sx={{
                      mb: 2,
                      textAlign: 'left',
                      lineHeight: lineHeights.headingMdTight,
                      fontFamily: typography.fontFamily,
                      color: naturalScale[5]
                    }}
                  >
                    Create Menus That Wow—In Minutes, Not Hours!
                  </Typography>
                  <Typography
                    // variant="body1"
                    // color="text.secondary"
                    sx={{
                      mb: 3,
                      textAlign: 'left',
                      lineHeight: 1.5,
                      fontFamily: typography.fontFamily,
                      color: colors.text.primary
                    }}
                  >
                    Design great-looking menus fast—drag, drop, pick a template, customize, and go live
                    instantly. No skills needed!
                  </Typography>
                </Box>
                <Box>
                  <img
                    src={QuickAction1}
                    alt="Create Menu"
                  />
                </Box>
              </Box>
              <Button
                variant="contained"
                onClick={() => navigate('/menus')}
                sx={{
                  bgcolor: colors.neutral.white,
                  color: colors.neutral.black,
                  py: 1.5,
                  mt: 'auto',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  borderRadius: borderRadius.xxxs,
                  border: '1px solid #0E0E14',
                  boxShadow: 'none',
                  width: 220,
                  '&:hover': {
                    bgcolor: colors.neutral.white,
                    boxShadow: 'none',
                    border: '1px solid #0E0E14',
                  },
                }}
              >
                Create Your First Menu
              </Button>

            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: '100%',
              borderRadius: borderRadius.xxs,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              transition: 'all 0.3s ease',
              '&:hover': {
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                transform: 'translateY(-4px)',
              },
            }}
          >
            <CardContent
              sx={{
                p: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                flexGrow: 1,
              }}>
                <Box>
                  <Typography
                    variant="subtitle1"
                    fontWeight={700}
                    fontFamily={typography.fontFamilyHeading}
                    sx={{
                      mb: 2,
                      textAlign: 'left',
                      lineHeight: lineHeights.headingMdTight,
                      fontFamily: typography.fontFamily,
                      color: naturalScale[5]
                    }}
                  >
                    Set It and Forget It—Your Menu Updates Itself!
                  </Typography>
                  <Typography
                    // variant="body1"
                    // color="text.secondary"
                    sx={{
                      mb: 3,
                      textAlign: 'left',
                      lineHeight: 1.5,
                      fontFamily: typography.fontFamily,
                      color: colors.text.primary
                    }}
                  >
                    Sync with FOODHUB and relax—prices and items update instantly, keeping your menu
                    always accurate, hassle-free.
                  </Typography>
                </Box>
                <Box>
                  <img
                    src={QuickAction2}
                    alt="Auto Sync"
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box >
  );
};

export default Dashboard;

